import { Card, CardHeader, CardBody, CardFooter, Button, Container, Row, Col, CardTitle } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import "../Styles/LoginStyle.css";


export const NotFound = () => {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate('/dashboard');
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center align-items-center " style={{ height: '100%',width:'100%' }}>
        <Col md="6">
          <Card>
          <CardHeader className="card_header text-dark">
            <CardTitle tag="h4" className="text-center">Pagina não encontrada</CardTitle>
          </CardHeader>
            <CardBody>
              <p>
                A página que você está procurando não foi encontrada. Clique no botão abaixo para retornar à página inicial.
              </p>
              <Button className="button_adjust" color="primary" onClick={handleNavigateHome}>
                Voltar para a Página Inicial
              </Button>
            </CardBody>
            <CardFooter className="card_footer text-white text-center">
            ConCredito. ©2025
          </CardFooter>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};